<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-row>
          <el-col :span="12" class="label-val">
            <span class="label">欠款时间：</span>
            <span class="value">{{ detail.debtTime || "-" }}</span>
          </el-col>
          <el-col :span="12" class="label-val">
            <span class="label">欠款金额：</span>
            <span class="value color52C41A"
              >￥{{ detail.debtAmount || "-" }}</span
            >
          </el-col>
          <el-col :span="12" class="label-val">
            <span class="label">司机姓名：</span>
            <span class="value">{{ detail.username || "-" }}</span>
          </el-col>
          <el-col :span="12" class="label-val">
            <span class="label">司机电话：</span>
            <span class="value">{{ detail.phone || "-" }}</span>
          </el-col>
          <el-col :span="12" class="label-val">
            <span class="label">所属机构：</span>
            <span class="value">{{ detail.companyName || "-" }}</span>
          </el-col>
          <el-col :span="12" class="label-val">
            <span class="label">车队长：</span>
            <span class="value">{{ detail.vehicleLeaderName || "-" }}</span>
          </el-col>
          <el-col :span="12" class="label-val">
            <span class="label">欠款类型：</span>
            <span class="value">{{
              getLocalLabel("debtType", detail.debtType)
            }}</span>
          </el-col>
        </el-row>
        <div class="title-box">
          <el-image :src="cheImage" class="title-label"></el-image>处理信息
        </div>
        <div class="examine2-box" v-if="isDetail">
          <div class="list">
            <span class="label">处理结果：</span>
            <span class="value">{{
              getLocalLabel("debtStatus", detail.debtStatus)
            }}</span>
          </div>
          <div class="list">
            <span class="label">还款方式：</span>
            <span class="value">{{
              getLocalLabel("paymentType", detail.paymentType)
            }}</span>
          </div>
          <div class="list">
            <span class="label">操作人：</span>
            <span class="value">{{ detail.handleUsername || "-" }}</span>
          </div>

          <div class="list">
            <span class="label">操作时间：</span>
            <span class="value">{{ detail.handleTime || "-" }}</span>
          </div>
          <div class="list" v-if="detail.handleRemark">
            <span class="label">备注：</span>
            <span class="value">{{ detail.handleRemark || "-" }}</span>
          </div>
          <div
            class="list"
            v-if="detail.vouchers && detail.vouchers.length > 0"
          >
            <span class="label">还款凭证：</span>
            <span class="value"></span>
          </div>
          <div
            class="list"
            v-if="detail.vouchers && detail.vouchers.length > 0"
          >
            <el-image
              v-for="(item, index) in detail.vouchers"
              :key="index"
              :src="getFileUrl(item.fileId)"
              class="info-img"
              :preview-src-list="[getFileUrl(item.fileId)]"
            ></el-image>
          </div>
        </div>
        <el-row :gutter="20" v-else>
          <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-col :span="24">
              <el-form-item prop="debtStatus" label="处理类型:">
                <el-radio-group v-model="form.debtStatus">
                  <el-radio :label="1">已还款</el-radio>
                  <el-radio :label="-1">作废</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <template v-if="form.debtStatus === 1">
              <el-col :span="24">
                <el-form-item prop="vouchers" label="付款凭证:">
                  <uploadFiles4 v-model="form.vouchers"></uploadFiles4>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备注:">
                  <el-input
                    type="textarea"
                    clearable
                    placeholder="请输入备注信息"
                    rows="5"
                    v-model="form.handleRemark"
                    show-word-limit
                    maxlength="50"
                  ></el-input>
                </el-form-item>
              </el-col>
            </template>
            <template v-if="form.debtStatus === -1">
              <el-col :span="24">
                <el-form-item prop="handleRemark" label="作废说明:">
                  <el-input
                    type="textarea"
                    clearable
                    placeholder="请输入作废说明"
                    rows="5"
                    v-model="form.handleRemark"
                    show-word-limit
                    maxlength="50"
                  ></el-input>
                </el-form-item>
              </el-col>
            </template>
          </el-form>
        </el-row>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import uploadFiles4 from "@/components/UploadFiles4.vue";
import {
  detailInfo,
  handleDebt,
} from "@/views/FinancialManagement/DriverDebtReceipt/api";
import { getLocalLabel } from "@/utils/localDict";
import { getFileUrl } from "@/utils/tool";

export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
    uploadFiles4,
  },
  data() {
    return {
      cheImage: require("@/assets/imgs/title.png"),
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "修改客户归属",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      detailImage: require("@/assets/imgs/bg.png"),
      isDetail: false,
      detail: {},
      form: {
        debtStatus: "",
        driverDebtId: "",
        handleRemark: "",
        vouchers: [],
      },
      rules: {
        handleRemark: [{ required: true, message: "作废说明不能为空" }],
        debtStatus: [{ required: true, message: "处理类型不能为空" }],
        vouchers: [{ required: true, message: "凭证不能为空" }],
      },
    };
  },
  mounted() {},
  methods: {
    getFileUrl,
    getLocalLabel,
    init(title, isDetail, row) {
      if (isDetail) {
        this.dialogObj.confirmFn = null;
      } else {
        this.dialogObj.confirmFn = this.submitForm;
      }
      this.dialogObj.title = title;
      this.isDetail = isDetail;
      this.form.driverDebtId = row.driverDebtId;
      if (!!row) {
        this.getDetailInfo(row.driverDebtId);
        // this.form = Object.assign({}, row);
      }
      this.dialogObj.show = true;
    },
    getDetailInfo(driverDebtId) {
      detailInfo(driverDebtId).then((res) => {
        if (res.code === 200) {
          this.detail = res.data;
        }
      });
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          const par = {
            debtStatus: this.form.debtStatus,
            driverDebtId: this.form.driverDebtId,
            handleRemark: this.form.handleRemark,
            vouchers: this.form.vouchers,
          };
          handleDebt(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("处理成功");
                this.$parent.handleAddOrEditSuccess("edit");
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .label-val {
    margin-bottom: 0.16rem;
  }
  .title-box {
    padding: 0.1rem 0 0.1rem;
    color: #000000;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .examine2-box {
    background-color: #f7fbff;
    border-radius: 0.08rem;
    padding: 0.1rem;
    box-sizing: border-box;
    margin-top: 0.1rem;
    .list {
      line-height: 0.2rem;
    }
    .info-img {
      width: 1rem;
      height: 1rem;
      border-radius: 0.1rem;
      margin-top: 0.1rem;
      margin-right: 0.1rem;
    }
  }
}
</style>
